<template>
    <div style="background-color: #ffffff">
        <div style="margin-top: 5px">
            <div class="kuang-item">
                <span>姓名</span>
                <el-input v-model="form.memberName" size="small" placeholder="请输入姓名" class="ki"></el-input>
            </div>
            <div class="kuang-item">
                <span>手机</span>
                <el-input v-model="form.phone" size="small" placeholder="请输入号码" class="ki"></el-input>
            </div>
            <div class="kuang-item">
                <span>生日</span>
                <div class="srdate1" @click="toShiJian('1')">{{form.srDate}}</div>
            </div>
            <div class="kuang-item">
                <span>性别</span>
                <div class="mb-sex">
                    <el-radio-group v-model="form.sex" style="margin-top: 20px;margin-left: 17px">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2" style="margin-left: -10px">女</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="kuang-item1">
                <span>进店渠道</span>
                <div class="srdate1" :class="{'active': qdName=='选择渠道'}" @click="toQd()">{{qdName}}</div>
            </div>
            <div class="kuang-item1">
                <span>会员权益</span>
                <div class="srdate1" @click="toQy()" :class="{'active': qyName=='选择权益'}">{{qyName}}</div>
            </div>
            <div class="kuang-item1">
                <span>第一负责人</span>
                <div class="srdate1" :class="{'active': fName=='请选择'}" @click="toEmps('1')">{{fName}}</div>
            </div>
            <div class="kuang-item1">
                <span>第二负责人</span>
                <div class="srdate1" :class="{'active': sName=='请选择'}" @click="toEmps('2')">{{sName}}</div>
            </div>
            <div class="kuang-item1">
                <span>第三负责人</span>
                <div class="srdate1" :class="{'active': tName=='请选择'}" @click="toEmps('3')">{{tName}}</div>
            </div>
               <div class="kuang-item2">
                   <van-cell-group custom-class="goods-cell-group" :border="false">
                       <van-cell>
                           <div style="display: flex;flex-direction: column;">
                               <span style="font-size: 13px">备注</span>
                               <el-input type="textarea" :rows="4"  size="mini" resize="none"  v-model="form.remarks" show-word-limit maxlength="30">
                               </el-input>
                           </div>
                       </van-cell>
                   </van-cell-group>
               </div>
        </div>
        <div class="mb-btn">
            <van-button type="default" class="quedingbtn" @click="updateMember('1')">确认编辑</van-button>
        </div>
        <van-popup v-model="sjShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    :min-date="minDate"
                    @confirm="queding"
                    @cancel="quxiao"
            />
        </van-popup>

        <van-popup v-model="qdShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-picker show-toolbar  title="进店渠道" @cancel="qdShow = false" :columns="qds" @confirm="qdConfirm"  />
        </van-popup>
        <van-popup v-model="qyShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-picker show-toolbar  title="会员权益" @cancel="qyShow = false" :columns="qys" @confirm="qyConfirm"/>
        </van-popup>
        <van-popup v-model="empShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-picker show-toolbar  title="负责人列表" @cancel="empShow = false" :columns="empNames" @confirm="empConfirm"/>
        </van-popup>
    </div>
</template>

<script>

    import {formatDate, getCookie} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                deptId:'',
                token:'',
                form: {
                    memberName: '',
                    sex: 1,
                    phone: '',
                    srDate: formatDate(new Date(), 'yyyy-mm-dd'),
                    mbSource:'',
                    levelId:'',
                    oneId:'',
                    twoId:'',
                    threeId:'',
                    remarks:'',
                },

                sjShow: false,
                dateType: '',
                minDate: new Date("1900-01-01"),
                currentDate: new Date(),

                qdName:'选择渠道',
                qdShow:false,
                qds:[
                    '自来','抖音','美团','小红书','私域商城'
                ],
                qdMap:{
                    '自来':0, '抖音':1, '美团':2, '小红书':3, '私域商城':5,
                },
                qdMap1:{
                    0:'自来', 1:'抖音', 2:'美团', 3:'小红书', 5:'私域商城',
                },
                qyName:'选择权益',
                qyShow:false,
                qys:[],
                lvs:[],

                fName:'请选择',
                sName:'请选择',
                tName:'请选择',
                fEmps:[],
                sEmps:[],
                tEmps:[],
                empShow:false,
                empType:'',
                emps:[],
                empNames:[],
            };
        },
        props:{
            addType:String,
            memberId:String
        },
        async created() {
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            await this.getEmpList()
            await this.getPlusList()
            this.getMemberInfo()
        },
        methods: {
            // chushi(){
            //     this.getMemberInfo()
            // },
            async getMemberInfo(){
                let res = await this.$get("/fw/getEditMember", {memberId:this.memberId});
                let srDate =formatDate(new Date(), 'yyyy-mm-dd')
                if (res.member.birthday){
                    srDate=formatDate(new Date(res.member.birthday), 'yyyy-mm-dd')
                }
                if (res.member.mbSource!=null){
                    let name =this.qdMap1[res.member.mbSource]
                    this.qdName=name
                }
                if (res.member.levelId){
                    this.lvs.forEach(item=>{
                        if (item.id==res.member.levelId){
                            this.qyName=item.plusName
                        }
                    })
                }
                if (res.member.oneId){
                    this.fName=res.member.oneName
                }
                if (res.member.twoId){
                    this.sName=res.member.twoName
                }
                if (res.member.threeId){
                    this.tName=res.member.threeName
                }
                this.form={
                    id:res.member.id,
                    memberName: res.member.memberName,
                    sex: res.member.sex,
                    phone: res.member.phone,
                    srDate:srDate,
                    mbSource:res.member.mbSource,
                    levelId:res.member.levelId,
                    oneId:res.member.oneId,
                    twoId:res.member.twoId,
                    threeId:res.member.threeId,
                    remarks:res.member.remarks,
                }
            },
            toShiJian(type) {
                this.dateType = type
                this.sjShow = true
            },

            toQd(){
                this.qdShow= true
            },
            qdConfirm(val){
                this.form.mbSource=this.qdMap[val]
                this.qdName=val
                this.qdShow= false
            },
            toQy(){
                this.qyShow= true
                this.getPlusList()
            },
            qyConfirm(val,index){
                let lv = this.lvs[index]
                this.qyName=lv.plusName
                this.form.levelId=lv.id
                this.qyShow= false
            },
            async getPlusList(){
                let res = await this.$get("/fw/getPlusLevels", {token:this.token});
                if (res.lvs){
                    res.lvs.forEach(item=>{
                        this.qys.push(item.plusName)
                    })
                    this.lvs=res.lvs
                }
            },

            toEmps(empType){
                this.empNames=[]
                this.emps=[]
               if (!this.empType){
                   this.getEmpList(empType)
               }else {
                   if (empType=='1'){
                           this.emps=this.fEmps
                           this.fEmps.forEach(item=>{
                               this.empNames.push(item.nickName)
                           })
                   }
                   if (empType=='2'){
                           this.emps=this.sEmps
                           this.sEmps.forEach(item=>{
                               this.empNames.push(item.nickName)
                           })
                   }
                   if (empType=='3'){
                           this.emps=this.tEmps
                           this.tEmps.forEach(item=>{
                               this.empNames.push(item.nickName)
                           })
                   }
               }
                this.empShow= true
                this.empType=empType
            },
            empConfirm(val,index){
                if (this.emps.length>0){
                    let emp = this.emps[index]
                    if (this.empType=='1'){
                        this.fName=emp.nickName
                        this.form.oneId=emp.id
                    }
                    if (this.empType=='2'){
                        this.sName=emp.nickName
                        this.form.twoId=emp.id
                    }
                    if (this.empType=='3'){
                        this.tName=emp.nickName
                        this.form.threeId=emp.id
                    }
                }
                this.empShow= false
            },
            //获取员工列表
            async getEmpList(empType) {
                let res = await this.$get("/sw/getSwEmpList", {token: this.token});
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                if (empType=='1'){
                    this.emps=res.fEmps
                    res.fEmps.forEach(item=>{
                        this.empNames.push(item.nickName)
                    })
                }
                if (empType=='2'){
                    this.emps=res.sEmps
                    res.sEmps.forEach(item=>{
                        this.empNames.push(item.nickName)
                    })
                }
                if (empType=='3'){
                    this.emps=res.tEmps
                    res.tEmps.forEach(item=>{
                        this.empNames.push(item.nickName)
                    })
                }
            },
            async updateMember() {
                    let res = await this.$post("/fw/updateMember", this.form)
                    if (res.code == 200) {
                        this.$notify({type: 'success', message: res.message});
                        this.getMemberInfo()
                    } else {
                        this.$notify({type: 'danger', message: res.message});
                    }
            },

            queding(val) {
                let date = formatDate(val, 'yyyy-mm-dd')
                this.form.srDate = date
                this.quxiao()
            },
            fanhui(member){
                this.$emit('gbMember',memberinfo)
            },
            quxiao() {
                this.sjShow = false
            },
        },
    };
</script>

<style lang="scss" scoped>

    .kuang-item {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        font-size: 13px;
        border-bottom: #EEEEEE solid 1px;
        height: 50px;
        line-height: 60px;
    }
    .ki {
        width: 60%;
    }

    .mb-sex {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 40px;
    }
    .kuang-item1 {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 13px;
        border-bottom: #EEEEEE solid 1px;
        height: 50px;
        line-height: 60px;
    }
    .srdate1 {
        display: block;
        margin-left: 15.5px;
        text-align: right;
    }
    .active {
        color: #C0C4CC;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff !important;
        border-radius: 0px;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #ffffff;
        cursor: not-allowed;
    }

    .mb-btn {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 20%;
        padding-bottom: 20px;
    }
    .quedingbtn {
        width: 100%;
        text-align: center;
        height: 40px;
    }

    .kuang-item2 {
        margin-left: 2px;
        font-size: 13px;
    }

</style>